import { render, staticRenderFns } from "./DallyM.vue?vue&type=template&id=0da80a74"
import script from "./DallyM.vue?vue&type=script&lang=js"
export * from "./DallyM.vue?vue&type=script&lang=js"
import style0 from "./DallyM.vue?vue&type=style&index=0&id=0da80a74&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports